import { useMemo } from "react";
import { ProductSubscribeGate } from "../../../products/subscribe_gate/ProductSubscribeGate";
import { membershipCanEnterRetailPurchase, membershipRetailPurchaseState } from "../../../products/membership/membershipPurchaseUtils";
import type { MembershipProduct, SpaceProfile } from "../SpaceType";
import { listBundlesContainingProduct, membershipNoRetailPurchaseHint } from "../spacePageUtils";
import { BundlePlanPurchaseActions } from "./BundlePlanPurchaseActions";
import { SpaceHomeMembershipSection } from "./SpaceHomeMembershipSection";

export function SpaceModuleSubscribeGate(props: {
  spaceId: string;
  row: MembershipProduct;
  membershipProducts: MembershipProduct[];
  isLoggedIn: boolean;
  onLoginRequest: () => void;
  spaceProfile: SpaceProfile | null;
}): JSX.Element {
  const { spaceId, row, membershipProducts, isLoggedIn, onLoginRequest, spaceProfile } = props;
  const { canBuyRetail, isNonStandalone } = membershipRetailPurchaseState(row);
  const upgradeEligible =
    row.upgradeEligible === true && !!row.upgradeSourceSpaceProductId?.trim();
  const bundles = useMemo(
    () => listBundlesContainingProduct(membershipProducts, row.spaceProductId),
    [membershipProducts, row.spaceProductId]
  );
  const showNonStandaloneFallbackHint =
    isNonStandalone && !canBuyRetail && bundles.length === 0;
  const isGift = row.pricingMode?.trim().toLowerCase() === "gift";
  const isFollowerFree = row.pricingMode?.trim().toLowerCase() === "follower_free";
  const showGiftPosterHint =
    isGift && !canBuyRetail && !upgradeEligible && bundles.length === 0;
  const showFollowerFreePosterHint =
    isFollowerFree && !canBuyRetail && !upgradeEligible && bundles.length === 0;

  return (
    <ProductSubscribeGate row={row}>
      <div className="space-poster-subscribe-actions">
        <BundlePlanPurchaseActions
          spaceId={spaceId}
          row={row}
          membershipProducts={membershipProducts}
          isLoggedIn={isLoggedIn}
          onLoginRequest={onLoginRequest}
          spaceProfile={spaceProfile}
          variant="platform"
          bundleCtaLabel={
            isNonStandalone ? "购买包含此服务的套餐" : undefined
          }
        />
        {(membershipCanEnterRetailPurchase(row) || upgradeEligible) ? (
          <SpaceHomeMembershipSection
            spaceId={spaceId}
            row={row}
            isLoggedIn={isLoggedIn}
            onLoginRequest={onLoginRequest}
            spaceProfile={spaceProfile}
            subscribeCtaLabel="订阅"
            subscribeCtaPresentation="button"
            subscribePrimaryButtonClassName="space-access-gate__subscribe-btn"
          />
        ) : showNonStandaloneFallbackHint || showGiftPosterHint || showFollowerFreePosterHint ? (
          <span className="space-m-no-spec-hint">
            {membershipNoRetailPurchaseHint(row)}
          </span>
        ) : null}
      </div>
    </ProductSubscribeGate>
  );
}
